// import { debounce } from 'lodash';
import { setSliceImageStrokeInfo } from '../slices/FJSliceImageStroke';

const FJActionImageStroke = {
    /**
     * @desc 更改图片描边信息
     * @param {{}} value
     * @returns
     */
    onStrokeChangeAction: strokeInfo => {
        return dispatch => {
            dispatch(setSliceImageStrokeInfo(strokeInfo));
        };
    },
};

export default FJActionImageStroke;
